import * as yup from "yup";
import { CustomFieldLabelSchema } from "./customFieldLabel";
import { AI_VISIBILITY } from "../enums";
import {
  BLANK_TIPTAP_JSON,
  PlainTextFieldSchema,
  TipTapFieldSchema,
} from "./tipTapField";

export { extractTextFromTipTap, MAX_NUM_CHARACTERS_PER_FIELD } from "./tipTapField";

export const MAX_NUM_ENTRIES_PER_PROJECT = 2_000;
export const MAX_NUM_CUSTOM_FIELDS = 2_000;
export { MAX_NUM_CHARACTERS_PER_FIELD_LABEL } from "./customFieldLabel";

export { BLANK_TIPTAP_JSON };

export function generateId(length) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const CustomFieldSchema = yup.object().shape({
  id: yup
    .string()
    .required()
    .default(() => generateId(10)),
  label: CustomFieldLabelSchema,
  value: TipTapFieldSchema.default(BLANK_TIPTAP_JSON),
  aiVisibility: yup.string().oneOf(Object.values(AI_VISIBILITY)).required().default(AI_VISIBILITY.AUTO),
});

export const DEFAULT_ENTRY_CUSTOM_FIELDS = [];

export const field = (label) => ({
  id: label.toLowerCase().replace(" ", "_"),
  label,
  value: BLANK_TIPTAP_JSON,
});

export const DEFAULT_ROLES = [
  {
    name: "Custom",
    optionValue: "sudo-custom",
    defaultFields: [
      //
      field("Description"),
    ],
  },
  {
    name: "Setting",
    optionValue: "setting",
    defaultFields: [
      //
      field("Sensory Description"),
      field("Location"),
    ],
  },
  {
    name: "Organization",
    optionValue: "organization",
    defaultFields: [
      //
      field("Goals"),
      field("History"),
      field("Headquarters"),
    ],
  },
  {
    name: "Lore",
    optionValue: "lore",
    defaultFields: [
      //
      field("Description"),
    ],
  },
  {
    name: "Key Event",
    optionValue: "key_event",
    defaultFields: [
      //
      field("When it happened"),
      field("What happened"),
      field("Implications"),
    ],
  },
  {
    name: "Clue",
    optionValue: "clue",
    defaultFields: [
      //
      field("Sensory Description"),
      field("Implications"),
    ],
  },
  {
    name: "Magic System",
    optionValue: "magic_system",
    defaultFields: [
      //
      field("Source of Magic"),
      field("Who can use Magic"),
      field("Schools or Types of Magic"),
    ],
  },
  {
    name: "Item",
    optionValue: "item",
    defaultFields: [
      //
      field("Physical Description"),
      field("Who owns this item"),
    ],
  },
  {
    name: "Technology",
    optionValue: "technology",
    defaultFields: [
      //
      field("Description"),
      field("History of Technology"),
      field("Effect on Society"),
    ],
  },
  {
    name: "Government",
    optionValue: "government",
    defaultFields: [
      //
      field("Type of Government"),
      field("Laws and enforcement"),
      field("Relationship with the governed"),
    ],
  },
  {
    name: "Economy",
    optionValue: "economy",
    defaultFields: [
      //
      field("Currency used"),
      field("Key Industries"),
      field("Trade Systems"),
    ],
  },
  {
    name: "Culture",
    optionValue: "culture",
    defaultFields: [
      //
      field("Traditions and Customs"),
      field("Language and dialects"),
      field("Arts and Entertainment"),
    ],
  },
  {
    name: "Religion",
    optionValue: "religion",
    defaultFields: [
      //
      field("Deities or spiritual beliefs"),
      field("Practices and Rituals"),
      field("Influence on Culture"),
    ],
  },
];

// this is the frontend structure, for validating the form
// we only deal with plaintext values on the server
export const WorldbuildingEntrySchema = yup.object().shape({
  userId: yup.string().required(),
  projectId: yup.string().required(),
  seriesId: yup.string().notRequired(),
  name: TipTapFieldSchema.default(BLANK_TIPTAP_JSON),
  role: PlainTextFieldSchema,
  otherNames: TipTapFieldSchema.default(BLANK_TIPTAP_JSON),
  customFields: yup.array().of(CustomFieldSchema).max(MAX_NUM_CUSTOM_FIELDS).default(DEFAULT_ENTRY_CUSTOM_FIELDS),
  createdAt: yup
    .date()
    .required()
    .default(() => new Date()),
  updatedAt: yup.date().notRequired(),
  deletedAt: yup.date().notRequired(),
  displayOrder: yup.number().required().default(10),
  collapsed: yup.bool().required().default(false),
  aiVisibility: yup.string().oneOf(Object.values(AI_VISIBILITY)).required().default(AI_VISIBILITY.AUTO),
});
